import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SEOSection = ({ 
  formData, 
  errors, 
  onChange 
}) => {
  const metaTitleLength = formData?.metaTitle?.length || 0;
  const metaDescriptionLength = formData?.metaDescription?.length || 0;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          SEO настройки
        </h3>
        <p className="text-sm text-text-secondary mb-6">
          Оптимизация для поисковых систем и социальных сетей
        </p>
      </div>
      <div>
        <Input
          label="Meta заголовок"
          type="text"
          name="metaTitle"
          placeholder="Аренда помещений | Ваш бизнес"
          value={formData?.metaTitle}
          onChange={onChange}
          error={errors?.metaTitle}
          maxLength={60}
          description={`${metaTitleLength}/60 символов. Оптимально: 50-60`}
          className="mb-2"
        />
        <div className="bg-muted p-3 md:p-4 rounded-lg">
          <p className="text-xs md:text-sm font-medium text-primary mb-1">
            {formData?.metaTitle || 'Заголовок страницы'}
          </p>
          <p className="text-xs text-text-secondary line-clamp-2">
            {formData?.metaDescription || 'Описание страницы появится здесь'}
          </p>
        </div>
      </div>
      <Input
        label="Meta описание"
        type="text"
        name="metaDescription"
        placeholder="Аренда офисов, коворкингов и рабочих мест в центре города"
        value={formData?.metaDescription}
        onChange={onChange}
        error={errors?.metaDescription}
        maxLength={160}
        description={`${metaDescriptionLength}/160 символов. Оптимально: 150-160`}
        className="mb-4"
      />
      <Input
        label="Ключевые слова"
        type="text"
        name="metaKeywords"
        placeholder="аренда офиса, коворкинг, рабочее место"
        value={formData?.metaKeywords}
        onChange={onChange}
        error={errors?.metaKeywords}
        description="Разделяйте запятыми"
        className="mb-4"
      />
      <div className="border-t border-border pt-6">
        <h4 className="text-base md:text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Share2" size={20} />
          Open Graph (социальные сети)
        </h4>

        <Input
          label="OG заголовок"
          type="text"
          name="ogTitle"
          placeholder="Заголовок для социальных сетей"
          value={formData?.ogTitle}
          onChange={onChange}
          error={errors?.ogTitle}
          description="Отображается при публикации в соцсетях"
          className="mb-4"
        />

        <Input
          label="OG описание"
          type="text"
          name="ogDescription"
          placeholder="Описание для социальных сетей"
          value={formData?.ogDescription}
          onChange={onChange}
          error={errors?.ogDescription}
          className="mb-4"
        />

        <Input
          label="OG изображение (URL)"
          type="url"
          name="ogImage"
          placeholder="https://example.com/image.jpg"
          value={formData?.ogImage}
          onChange={onChange}
          error={errors?.ogImage}
          description="Рекомендуемый размер: 1200x630 пикселей"
        />
      </div>
    </div>
  );
};

export default SEOSection;